import { getDeadlineField, getDeadlineResultPresentation } from '../deadlineResultPresentation'

function formatPercent(value) {
  if (value === null || value === undefined || value === '') return 'Não informado'
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) return String(value)
  return `${Math.round(numericValue * 100)}%`
}

function SummaryItem({ label, value, helper }) {
  return (
    <div className="deadline-summary-item">
      <span>{label}</span>
      <strong>{value || 'Não informado'}</strong>
      {helper ? <small>{helper}</small> : null}
    </div>
  )
}

export default function DeadlineSummaryCard({ result, presentation = getDeadlineResultPresentation(result) }) {
  const context = result.context || {}
  const audit = result.audit || {}

  return (
    <section className="rules-card deadline-result-section deadline-summary-card">
      <div className="rules-card-header">
        <div>
          <h3>Resumo da simulação</h3>
          <p>Campos principais retornados pelo DeadlineEngine.</p>
        </div>
        <span className={`status-badge ${presentation.tone}`}>{presentation.label}</span>
      </div>

      <div className="rules-card-body deadline-summary-grid">
        <SummaryItem label="Status" value={presentation.label} />
        <SummaryItem label="Revisão humana" value={presentation.humanReviewRequired ? 'Necessária antes de confirmar o prazo' : 'Não obrigatória'} helper={getDeadlineField(result, 'reviewReason')} />
        <SummaryItem label="Área" value={context.area} />
        <SummaryItem label="Regime" value={context.regime} />
        <SummaryItem label="Microssistema" value={context.microsystem} />
        <SummaryItem label="Natureza do documento" value={context.documentNature} helper={`Confiança do contexto: ${formatPercent(context.confidence)}`} />
        <SummaryItem label="Texto normalizado" value={result.normalizedText ? 'Disponível' : 'Não retornado'} />
        <SummaryItem label="Simulação" value={audit.simulationId} helper={audit.createdAtUtc} />
      </div>
    </section>
  )
}
